/**
 * Language switcher — one tap toggles between English and Tamil.
 *
 * Shows the language you will switch *to*, written in that language's script
 * (EN / தமிழ்), so it stays recognisable without taking two buttons of space.
 */

import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES, setLanguage, type LanguageCode } from '../i18n'

function toggleLabel(code: LanguageCode): string {
  return code === 'en' ? 'EN' : 'தமிழ்'
}

export function LanguageToggle() {
  const { i18n, t } = useTranslation()
  const current = i18n.language.split('-')[0] as LanguageCode
  const other =
    SUPPORTED_LANGUAGES.find((lang) => lang.code !== current) ?? SUPPORTED_LANGUAGES[1]

  return (
    <button
      type="button"
      lang={other.code}
      aria-label={t('common.switchLanguage', { language: other.label })}
      title={other.label}
      onClick={() => setLanguage(other.code)}
      className="tap-target rounded-lg px-2.5 text-sm font-semibold text-stone-600 hover:bg-stone-100 hover:text-brand-800"
    >
      {toggleLabel(other.code)}
    </button>
  )
}
